(function(){
  // biomarker explorer
  var search=document.querySelector('.exsearch'), groups=[].slice.call(document.querySelectorAll('.bgroup'));
  var filters=[].slice.call(document.querySelectorAll('.bfilter')), countEl=document.querySelector('.excount b');
  var total=countEl?parseInt(countEl.getAttribute('data-total'),10):0, empty=document.querySelector('.exempty');
  var focus='all';
  function apply(){
    var q=(search&&search.value||'').trim().toLowerCase(); var shown=0, anyGroup=false;
    groups.forEach(function(g){
      var tags=(g.getAttribute('data-tags')||'').split(' ');
      var focusOk = focus==='all' || tags.indexOf(focus)>-1;
      var chips=[].slice.call(g.querySelectorAll('.bmk')); var gvis=0;
      chips.forEach(function(c){
        var name=c.getAttribute('data-name');
        var match = q && name.indexOf(q)>-1;
        c.classList.toggle('match', !!match);
        var visible = focusOk && (!q || match);
        c.classList.toggle('dim', q && !match && focusOk);
        if(focusOk && (!q || match)) gvis++;
      });
      var show = focusOk && (!q || gvis>0);
      g.classList.toggle('hide', !show);
      if(show){ anyGroup=true; shown += (q? gvis : chips.length); }
    });
    if(countEl) countEl.textContent = (q||focus!=='all')? shown : '100+';
    if(empty) empty.style.display = anyGroup? 'none':'block';
  }
  // On a phone the explorer collapses: every category shut except the first, so the
  // section reads as a scannable list. Heart and Metabolic stay open because they are
  // what people came to check. A search opens whatever it matches, and closes
  // the rest, so a result is never hidden behind a closed group.
  var MOB=window.matchMedia('(max-width:700px)');
  function collapse(){
    if(!MOB.matches) return;
    groups.forEach(function(g,i){ g.open = (i===1||i===2); });
  }
  function expandAll(){ groups.forEach(function(g){ g.open = true; }); }
  function syncOpen(q){
    if(!MOB.matches) return;
    if(!q){ collapse(); return; }
    groups.forEach(function(g){ g.open = !g.classList.contains('hide'); });
  }
  collapse();
  MOB.addEventListener('change', function(e){ e.matches? collapse() : expandAll(); });
  if(search) search.addEventListener('input', function(){ apply(); syncOpen(search.value.trim()); });
  filters.forEach(function(f){ f.addEventListener('click', function(){ focus=f.getAttribute('data-focus'); filters.forEach(function(x){x.classList.toggle('on',x===f);}); apply();
    if(MOB.matches){ var vis=groups.filter(function(g){return !g.classList.contains('hide');});
      groups.forEach(function(g){ g.open=false; });
      if(focus!=='all') vis.forEach(function(g){ g.open=true; }); else collapse(); }
  }); });
})();
